import type { VersionedWording } from '@/lib/versioned-labels';

/**
 * How the versioned layer names a persona, everywhere it has to (refonte
 * modulaire §10).
 *
 * The twin of `criterion-wording.tsx`, and it is deliberately a copy rather
 * than a template over « persona » : French articles and agreements are not a
 * concatenation, and the referents differ. A criterion is cited by PROTOCOLES ;
 * a persona is chosen by an EXPÉRIENCE (§10.2) and by nothing else, so every
 * sentence of the retirement names experiences and agrees in the feminine.
 * `developmentHint` names them too (issue #155): the FIRST sentence of the
 * maquette `EnregistrerVersion`. Its second promised the development links the
 * new version at their next session, which §5.2 contradicts - an experience
 * cites a persona at `production` by default, and a session resolves it there
 * - and the spec rules on substance where the maquette rules on form.
 *
 * Like the criterion's, this file is a `.tsx` and holds no component: the two
 * hints of the retirement are JSX for the reason `criterion-wording.tsx`
 * argues at length - a name spliced into a template is ONE text node where the
 * prose around it is its own, Chrome measures each node separately, and the two
 * shapes land the tail of the line a third of a pixel apart.
 *
 * The two prefixes are what every `data-testid` of the screen is built from,
 * which is why they are spelled WITHOUT an accent and in the singular then the
 * plural: `persona-carte` and `personas-grille` are what `personas.spec.ts` and
 * `screenshots-personas.mjs` read, and a mark nobody can type is a mark nobody
 * can assert on.
 */
export const PERSONA_WORDING: VersionedWording = {
  kind: 'persona',
  entity: 'persona',
  list: 'personas',
  noun: ['persona', 'personas'],
  newTitle: 'Nouveau persona',
  createLabel: 'Créer un nouveau persona',
  developmentHint: () =>
    'Un persona n’est cité que par des expériences : ce sont les seuls référents qui peuvent apparaître ici.',
  subject: (name) => `Persona « ${name} »`,
  retirement: {
    panelTitle: 'Retirer ce persona',
    retiredTitle: 'Persona retiré',
    confirmLabel: 'Retirer le persona',
    panelHint: (name) => (
      <>
        Il n’est plus proposé aux expériences. Celles qui le citent gardent un avertissement «
        remplacer le persona {name} » jusqu’au remplacement. Restauration possible depuis
        l’historique.
      </>
    ),
    retiredHint: (name, day) => (
      <>
        Retiré le {day}. Il n’est plus proposé aux expériences, et les expériences qui le citent
        portent l’avertissement « remplacer le persona {name} » jusqu’au remplacement. Les sessions
        passées gardent leur gel.
      </>
    ),
    warningTitle: (name) => `Chacune gardera « remplacer le persona ${name} »`,
  },
  refusal: {
    nameTaken: 'Ce nom est déjà porté par un autre persona. Choisissez-en un autre.',
    nameTakenBy: (name) =>
      `« ${name} » porte déjà ce nom. Choisissez-en un autre, ou renommez d’abord l’autre persona.`,
    retired: 'Ce persona est retiré. Restaurez-le avant de le modifier.',
  },
};
